import React, { useState } from 'react';
import '../../src/calculator/feed/FeedCalculator.css';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import Rating from 'react-rating';
import ButtonFrame from '../snippets/ButtonFrame';
import { reviewCalculator } from '../action/functions';
import './CalculatorReview.css'
import '../components/Navbar.css'

const CalculatorReview = ({account, reviewType, closeRatingModal}) => {

  const [rating, setRating] = useState(1);
  const [review, setReview] = useState('');
  const [ratingView, setReviewView] = useState(true);
  const [reviewSuccess, setReviewSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const openReviewSuccess = () => {
    setReviewView(false);
    setReviewSuccess(true);
  }

  const closeReviewSuccess = () => {
    setReviewSuccess(false);
    closeRatingModal();
  }

  const submit = async () => {
    setLoading(true);
    const data = {
      review_type: reviewType.id,
      rating: rating,
      review: review
    };
    
    const result = await reviewCalculator(account.token, data);
    if (result.status) {
      openReviewSuccess();
      setLoading(false);
    }else {
      alert(result.message);
      setLoading(false);
    }
  }


  return (
    <>
      {ratingView && (
        <div className="review-modal-overlay" onClick={closeRatingModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src="/assets/close.png" alt="Close Icon" className='signup-close-icon' onClick={closeRatingModal} />        
            <div className='modal-main-container'>
              <div className='rating-header'>
                <h2 className="modal-title">Rate Calculator</h2>
                <p className='rating-text'>Rate your experience using My {reviewType.name} Calculator.</p>
              </div>
              <div className='rating-star-container'>
                <div className='rating-container'>
                  <Rating
                    initialRating={rating}
                    emptySymbol={<img src="/assets/empty_star.svg" alt="empty star" className="star" />}
                    fullSymbol={<img src="/assets/full_star.svg" alt="full star" className="star" />}
                    onChange={(rate) => {
                      setRating(rate);
                    }}
                          
                  />
                </div>
                <div className='rating-input-container'>
                  <textarea 
                    id="review" 
                    value={review} 
                    placeholder='Write a review...' 
                    onChange={(e) => setReview(e.target.value)} 
                    required
                    className="review-input-textarea"
                  >
                  </textarea>
                  <ButtonFrame handleClick={submit} loading={loading} btnText={"Submit"} classNameStyle={"rating-submit-btn"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {reviewSuccess && (
        <div className="modal-overlay" onClick={closeReviewSuccess}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <img src="/assets/close.png" alt="Close Icon" className='signup-close-icon' onClick={closeReviewSuccess} />
              <div className='modal-main-container'>
                <DotLottieReact
                  src="/assets/party-pop.json"
                  loop
                  autoplay
                  className='canvas'
                />
                <div className='signup-modal-container'>
                <h2 className="modal-title">Thank you! {account.fullname.split(" ")[0]}</h2>
                  <div className='modal-input-container'>
                    <p className='verify-text'>Your review means a lot to us!</p>
                  </div>
                </div>
              </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CalculatorReview;
